const usernameIsValid = username => {
	return username.length >= 1 && username.length <= 32;
};

const phoneNumberIsValid = phoneNumber => {
	var phoneno = /^\+(?:[0-9]●?){6,14}[0-9]$/;
	return phoneno.test(phoneNumber);
};

const passwordIsValid = pwd => {
	return pwd.length >= 6 && pwd.length <= 16;
};

const emailIsValid = email => {
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

const verificationCodeIsValid = code => {
	return code.length >= 1 && code.length <= 16;
};

export default (type, value) => {
	//console.log(name, this.state[name]);
	let isValid = false;
	switch (type) {
		case 'username':
			isValid = usernameIsValid(value);
			break;
		case 'password':
			isValid = passwordIsValid(value);
			break;
		case 'email':
			isValid = emailIsValid(value);
			break;
		case 'phoneNumber':
			isValid = phoneNumberIsValid(value);
			break;
		case 'verificationCode':
			isValid = verificationCodeIsValid(value);
			break;
		default:
			//
			break;
	}
	return isValid;
};
